import { render, staticRenderFns } from "./SearchSyncIncome.vue?vue&type=template&id=a89b2a66&scoped=true"
import script from "./SearchSyncIncome.vue?vue&type=script&lang=js"
export * from "./SearchSyncIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89b2a66",
  null
  
)

export default component.exports